import { validatePublicConfig } from "./publicConfig";

export const PUBLIC_CONFIG = validatePublicConfig({
    REACT_APP_SITE_URL: process.env.REACT_APP_SITE_URL,
    REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
});
// Missing configuration is reported by the startup gate, not an import-time crash.
export const SITE_URL = PUBLIC_CONFIG.siteUrl;
export const DEFAULT_SHARE_IMAGE = "/og-default.png";
export const publicImage = value => {
    if (!PUBLIC_CONFIG.valid) return undefined;
    if (!value) return SITE_URL + DEFAULT_SHARE_IMAGE;
    try { const url = new URL(value, SITE_URL); return ["http:", "https:"].includes(url.protocol) ? url.href : SITE_URL + DEFAULT_SHARE_IMAGE; }
    catch { return SITE_URL + DEFAULT_SHARE_IMAGE; }
};
export const privateSearchPage = (pathname, search) => {
    const query = new URLSearchParams(search);
    return /^\/(admin|account|login|auth|cart|checkout|buy|portal|volunteer-portal|claim-account|forgot-password|reset-password|confirm-email-change|unsubscribe|maintenance-preview)(\/|$)/.test(pathname)
        || pathname === "/donate/manage" || ["entry", "email", "token", "preview"].some(key => query.has(key));
};
export const isPreviewSite = () => !PUBLIC_CONFIG.valid || window.location.hostname !== new URL(SITE_URL).hostname;